import { Injectable } from '@angular/core';
import { BaseApiPickerImpl } from '../base.api-picker';
import { RemoteServiceApi } from './remote-service.api';
import { RemoteServiceMockApi } from './remote-service.mock-api';
import { AuthStore } from '../../../../app/@store';

@Injectable({ providedIn: 'root' })
export class RemoteServiceApiPicker extends BaseApiPickerImpl<
  RemoteServiceApi | RemoteServiceMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: RemoteServiceApi,
    protected mockApi: RemoteServiceMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
